import { FC } from 'react';
import { Box, ListItemStudyDocument, Subtitle2, Subtitle3 } from '@csp/csp-web-ui';
import { generatePath } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { useTrainingDocuments } from '../hook/useTrainingDocuments';
import { useVideoTrainingMeta } from '../hook/useVideoTrainingMeta';
import { useDownloadFile } from '../../study-documents/study-documents-file-list/hook/useDownloadFile';
import { ViewOrDownloadStudyDocumentListItem } from '../../study-documents/component/ViewOrDownloadStudyDocumentListItem';

export const TrainingMaterialsContainer: FC = () => {
  const trainingMaterialsContent = StaticContentService.getGenericBlock('webHcpTechnicalSupport', 'trainingMaterials');

  const trainingDocuments = useTrainingDocuments();
  const videoTrainingMeta = useVideoTrainingMeta();
  const downloadFileState = useDownloadFile();

  if (!trainingDocuments && !videoTrainingMeta) {
    return null;
  }

  return (
    <>
      <Box mb={3}>
        <Subtitle2 fontWeight={700} mb={1}>
          {trainingMaterialsContent.header.text}
        </Subtitle2>
        <Subtitle3>{trainingMaterialsContent.body.decription.text}</Subtitle3>
      </Box>

      {trainingDocuments?.map(file => (
        <Box mb={2} key={file.id}>
          <ViewOrDownloadStudyDocumentListItem
            file={file}
            versionPublishedLabel={trainingMaterialsContent.body.versionPublished.text}
            viewLabel={trainingMaterialsContent.button.view.label}
            labelWidth={{ xs: '70%', sm: '80%' }}
            downloadFileState={downloadFileState}
            viewUrl={generatePath(CspPath.DOCUMENT_PREVIEW, { fileId: file.id })}
          />
        </Box>
      ))}

      {videoTrainingMeta && (
        <Box mb={2}>
          <ListItemStudyDocument
            title={videoTrainingMeta.title}
            versionPublishedDate={videoTrainingMeta.versionPublishedDate}
            versionPublishedLabel={trainingMaterialsContent.body.versionPublished.text}
            linkText={trainingMaterialsContent.button.view.label}
            labelWidth={{ xs: '70%', sm: '80%' }}
            onClick={() => window.open(videoTrainingMeta.url)}
          />
        </Box>
      )}
    </>
  );
};
